import { SeoPageConfig } from "./seo-pages";

/**
 * Источники, с которых сервис умеет забирать аудиодорожку по ссылке.
 * Расширять список можно только вместе с поддержкой на бэкенде —
 * сейчас это YouTube (см. BASE_PAGES), VK Video и Rutube.
 */
export const SOURCE_PAGES: SeoPageConfig[] = [
  {
    path: "/vk-video-to-text",
    cardTitle: "Видео из VK Video",
    metaTitle: "Расшифровка видео из ВК в текст по ссылке, без скачивания",
    metaDescription:
      "Вставьте ссылку на ролик VK Video, сервис сам заберёт звук и вернёт текст с таймкодами и разделением по спикерам. Выгрузка в TXT, DOCX и SRT.",
    customTitle: "Расшифровка видео из VK Video",
    customSubtitle: "Вставьте ссылку на ролик — сервис сам заберёт звук и вернёт текст.",
    seoDescription: (
      <>
        <p>
          Для публичных роликов из VK Video файл скачивать не нужно: вставьте ссылку, и сервис заберёт аудиодорожку сам.
          Это заметно быстрее, особенно для длинных записей — вместо загрузки нескольких гигабайт передаётся только
          адрес.
        </p>
        <p>
          Работает это с открытыми публикациями. Ролики из закрытых сообществ, приватные записи и видео, доступные
          только друзьям, по ссылке недоступны — их придётся скачать и загрузить файлом. То же касается записей личных
          звонков.
        </p>
        <p>
          Ссылку можно взять как удобно: из адресной строки браузера, кнопкой «Поделиться» в приложении или из кода
          встраивания плеера. Приводить адрес к какому-то особому виду не нужно — сервис распознаёт и{" "}
          <code>vkvideo.ru/video-…</code>, и <code>vk.com/video-…</code>, и ссылку из поста на стене, и запись
          трансляции, которая в адресе выглядит как <code>live-…</code>. Таймкоды и рекламные метки в ссылке тоже не
          мешают: они отбрасываются перед обработкой.
        </p>
        <p>
          Для ВК это удобнее обычного скачивания ещё и потому, что универсальной кнопки «Скачать» у площадки нет:
          возможность сохранить ролик зависит от настроек автора и приватности записи. Если нужен именно текст, вопрос
          доступа к файлу не возникает вовсе — вы передаёте адрес, а не копию чужой записи.
        </p>
        <p>
          Результат приходит с автоматической пунктуацией, таймкодами и разделением по спикерам, а выгрузить его можно в
          TXT, DOCX, PDF или SRT — последнее удобно, если нужны субтитры к самому ролику.
        </p>
        <p>
          Выигрыш от работы по ссылке тем заметнее, чем длиннее ролик. Двухчасовая запись в хорошем качестве весит
          несколько гигабайт, и её загрузка с домашнего интернета занимает больше времени, чем сама расшифровка. При
          работе по ссылке передаётся только адрес, а звук забирается на стороне сервиса.
        </p>
        <p>
          Ограничение по длительности при этом сохраняется: до четырёх часов на одну обработку. Для стримов и
          многочасовых трансляций это означает, что запись придётся скачать и разрезать — по ссылке частями взять её не
          получится.
        </p>
        <p>
          Плейлисты обрабатываются по одному ролику: ссылка на подборку целиком не подойдёт, нужен адрес конкретного
          видео. Если роликов в серии много, проще собрать их адреса заранее и запускать по очереди.
        </p>
        <p>
          Списание идёт по длительности всей записи, а не по объёму речи в ней. Для интервью и лекций это несущественно,
          а вот в роликах с длинными музыкальными вставками или заставками стоит прикинуть заранее: сервис показывает
          оценку до запуска.
        </p>
      </>
    ),
    faq: [
      {
        question: "Нужно ли скачивать видео перед расшифровкой?",
        answer: "Нет, для открытых публикаций достаточно вставить ссылку — сервис заберёт аудиодорожку сам."
      },
      {
        question: "Почему ссылка на ролик не срабатывает?",
        answer:
          "Скорее всего, запись закрыта настройками приватности или доступна только участникам сообщества. Такие видео нужно скачать и загрузить файлом."
      },
      {
        question: "Списываются ли минуты за длину всего ролика?",
        answer:
          "Да, расчёт идёт по длительности записи. Перед запуском сервис показывает оценку, чтобы не было сюрпризов."
      },
      {
        question: "Можно ли сразу получить субтитры?",
        answer: "Да, результат выгружается в SRT — этот файл подключается к видео как дорожка субтитров."
      },
      {
        question: "Как получить ссылку на видео из ВК?",
        answer:
          "Тремя способами, и все подойдут. На компьютере — скопировать адрес из строки браузера на странице ролика. В приложении — кнопка «Поделиться» и «Скопировать ссылку». Из чужого сайта — код встраивания плеера: сервис разбирает его и достаёт адрес видео сам. Приводить ссылку к «правильному» виду не нужно, таймкоды и utm-метки можно не вычищать."
      },
      {
        question: "Подойдёт ли ссылка на трансляцию или код встраивания плеера?",
        answer:
          "Да. Ссылка на запись трансляции (в адресе она выглядит как live-…) распознаётся и обрабатывается как обычное видео, код встраивания — тоже. Не подойдёт только адрес подборки, сообщества или страницы поиска: нужен адрес конкретного ролика, потому что расшифровывается одна запись за раз."
      }
    ]
  },
  {
    path: "/rutube-to-text",
    cardTitle: "Видео из Rutube",
    metaTitle: "Расшифровка видео с Rutube в текст | Транскрибация по ссылке",
    metaDescription:
      "Транскрибация видео с Rutube в текст по ссылке без скачивания файла. Пунктуация, таймкоды, разделение по спикерам, выгрузка в DOCX и SRT.",
    customTitle: "Расшифровка видео с Rutube",
    customSubtitle: "Ссылка на ролик вместо загрузки файла — текст готов через несколько минут.",
    seoDescription: (
      <>
        <p>
          Rutube поддерживается наравне с YouTube и VK Video: вставьте ссылку на открытый ролик, и сервис сам достанет
          из него звук. Скачивать видео и искать конвертер не нужно, видеоряд для расшифровки не используется.
        </p>
        <p>
          Чаще всего так расшифровывают интервью, выпуски передач и записи конференций — то есть материал, который нужен
          в виде текста для цитирования или конспекта. Таймкоды помогают быстро найти нужный фрагмент в исходной записи,
          а разделение по спикерам разводит реплики ведущего и гостя.
        </p>
        <p>
          Если ролик закрыт настройками доступа, ссылка не сработает — в этом случае запись нужно скачать и загрузить
          обычным файлом.
        </p>
        <p>
          Материал на Rutube специфический: много телевизионного контента, интервью, записей передач и выступлений. Для
          распознавания это удачный набор — речь там поставленная, записана в студии или с петличным микрофоном, и
          точность на такой звуковой дорожке стабильно высокая.
        </p>
        <p>
          Сложнее с роликами, где поверх речи идёт музыкальная подложка или звук из зала. Модель отделяет голос от фона,
          но чем громче подложка относительно речи, тем больше пропусков. Для таких записей стоит выбирать режим
          «Качество».
        </p>
        <p>
          Ссылка избавляет от скачивания, и для длинных передач это ощутимая экономия времени. Ограничение то же, что и
          везде: до четырёх часов на одну обработку, поэтому многочасовые эфиры придётся резать на части и загружать
          файлами.
        </p>
        <p>
          Частый сценарий — цитирование. Из расшифровки берётся точная формулировка, а таймкод рядом позволяет сослаться
          на минуту в исходном ролике. Это заметно надёжнее, чем пересказ по памяти, и проверяется любым читателем за
          пару секунд.
        </p>
      </>
    ),
    faq: [
      {
        question: "Какие ссылки поддерживаются?",
        answer:
          "Ссылки на открытые ролики Rutube, а также YouTube и VK Video. Закрытые и приватные записи нужно загружать файлом."
      },
      {
        question: "Сколько занимает расшифровка часового ролика?",
        answer:
          "Обычно несколько минут. В быстром режиме обработка заметно короче, режим «Качество» работает дольше, но точнее."
      },
      {
        question: "Останется ли текст на языке оригинала?",
        answer:
          "Да, расшифровка выполняется на языке записи. Перевод не выполняется — готовый текст можно перевести отдельно."
      },
      {
        question: "Можно ли сделать из ролика конспект?",
        answer:
          "Да. После расшифровки доступна AI-сводка: краткое изложение и список ключевых моментов вместо полного текста."
      }
    ]
  }
];
